/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { DISCOUNT_CONSTANTS } from '../../../modules/discounts/reducers';
import { DiscountCollectionInterface } from '../../../interfaces/api/DiscountCollectionInterface';
import { useDispatch } from 'react-redux';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import SelectFromRest from '../../../components/Form/SelectFromRest';

interface CountryGroupSelectInterface {
    classes: any;
    setZone: (zone: string | null) => void;
    selected: string | null;
}

const CountryGroupSelect = (props: CountryGroupSelectInterface): React.ReactElement => {
    const ZONE_URL = '/zones';

    const { setZone, selected } = props;

    const dispatch = useDispatch();
    const [filters, setFilters] = useState<Array<Filter>>([{ name: 'customZoneType', value: 1 }]);
    const [orders, setOrders] = useState<Array<Order>>([]);
    const [zones, setZones] = useState<Array<any> | null>(null);
    const [selectedZone, setSelectedZone] = useState<string | null>(selected ?? null);

    const firstSerach = useCallback(() => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath(ZONE_URL)),
            DISCOUNT_CONSTANTS.LIST,
            filters,
            orders,
            (data: any) => {
                setZones(data);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }, [dispatch, filters, orders]);

    const change = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        setSelectedZone(e.target.value);
    };

    useEffect(() => {
        firstSerach();
    }, [firstSerach]);

    useEffect(() => {
        setZone(selectedZone);
    }, [setZone, selectedZone]);

    return (
        <div>
            <SelectFromRest
                classes={props.classes}
                callback={change}
                required={false}
                restElements={zones ?? { 'hydra:member': [] }}
                stateName="zoneId"
                stateObjectState={null}
                selectedValue={selectedZone}
                propKey="id"
                propValue="mainname"
                addEmpty={false}
                displayEmpty={true}
                emptyLabel="notifications:welcome_sms.empty"
                label="notifications:welcome_sms.select_zone"
            />
        </div>
    );
};

export default CountryGroupSelect;
